<template>
  <div class="flex flex-col">
    <label :for="name" class="text-[#385660] mb-1">
      {{ label }}<span v-if="required" class="ml-0.5">*</span>
    </label>
    <select :id="name" :name="name" v-model="internalValue" @change="onChange" :disabled="disabled"
      class="text-[#7CADB9] border border-[#3A5762] rounded-lg h-10.5 outline-none shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] max-w-[350px] p-2"
      :class="{ 'border-red-500': error, 'opacity-50 cursor-not-allowed': disabled }"
      >
      <option :disabled="!clearable" value="">{{ placeholder }}</option>
      <option v-for="(option, index) in options" :key="index" :value="option.value">
        {{ option.label }}
      </option>
    </select>
    <p v-if="error" class="text-red-500 text-xs pt-1">{{ error }}</p>
  </div>
</template>
<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
  label: String,
  name: String,
  required: {
    type: Boolean,
    default: false
  },
  error: {
  type: String,
  default: ''
},
  placeholder: {
    type: String,
    default: 'SELECCIONAR',
  },
  options: {
    type: Array || Boolean,
    default: () => [],
  },
  // Permite volver a la opción vacía (p. ej. quitar la tarifa de un inmueble)
  clearable: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  modelValue: [String, Number, Boolean],
});

const emit = defineEmits(['update:modelValue']);

const internalValue = ref(props.modelValue ?? '');

// Sincroniza si cambia desde fuera
watch(() => props.modelValue, (val) => {
  internalValue.value = val;
});

function onChange() {
  const val = internalValue.value;
  const parsedValue = val === 'true' ? true : val === 'false' ? false : val;
  emit('update:modelValue', parsedValue);
}

</script>
